import React from 'react';
import TableWrapper from '../TableControls/TableWrapper';
import PaginationControls from '../TableControls/PaginationControls';
import FilterSortControls from '../TableControls/FilterSortControls';
import './styles.css';

function HighSchoolMentorTable({ mentors, currentPage, resultsPerPage, onPageChange, totalResults, setSortOption, setSearchTerm, isAuthenticated }) {
    const totalPages = Math.ceil(totalResults / resultsPerPage);

    const columns = [
        { key: 'name', label: 'Name' },
        { key: 'email', label: 'Email' },
        { key: 'grade', label: 'Grade' },
        { key: 'di_experience', label: 'DI Experience' },
        { key: 'interest_area', label: 'Interest Area' },
    ];

    const renderRow = mentor => (
        <tr key={mentor.id}>
            <td>{mentor.name}</td>
            <td>{mentor.email}</td>
            <td>{mentor.grade}</td>
            <td>{mentor.di_experience ? 'Yes' : 'No'}</td> {/* Convert boolean to Yes/No */}
            <td>{mentor.interest_area}</td>
        </tr>
    );

    return (
        <div className="table-wrapper">
            <FilterSortControls
                sortOptions={columns}
                setSortOption={setSortOption}
                setSearchTerm={setSearchTerm}
                fromIndexResults={(currentPage - 1) * resultsPerPage + 1}
                toIndexResults={Math.min(currentPage * resultsPerPage, totalResults)}
                totalResults={totalResults}
            />
            <TableWrapper columns={columns} data={mentors} renderRow={renderRow} />
            <PaginationControls currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />
        </div>
    );
}

export default HighSchoolMentorTable;